import BindingContext from "@odata/BindingContext";

export const DateAccountingTypePath = "##DateAccountingType##";
export const DateReceivedTypePath = "##DateReceivedType##";
export const DraftIdsPath = "##DraftIds##";
export const IsTaxProformaDocumentPath = "##IsTaxProformaDocument##";

export const getCheckboxPath = (propertyPath: string): string => {
    const propertyName = BindingContext.cleanLocalContext(propertyPath).split("/").pop() ?? propertyPath;
    return BindingContext.localContext(`Replace${propertyName}`);
};

export const NoVatItem = "NoVatItem";

export enum DraftMassAccountingDateSource {
    Today = "Today",
    DateIssued = "DateIssued",
    DateReceived = "DateReceived",
    DateTaxableSupply = "DateTaxableSupply",
    Own = "Own"
}
